import React from 'react'

import { Settings, settingsConnector } from './Settings'

const DefaultCustomerSettings = props => <Settings {...props} defaultTenant />

export default settingsConnector(DefaultCustomerSettings)
